export const defaultPax = { adults: 2 };

const paxFilterKeys = { adults: 'adults', children: 'children', infants: 'infants' };

export default paxFilterKeys;
